// @flow
import React from "react";
import {Table} from "antd";
import moment from "moment";
import {useTranslation} from "react-i18next";
import {EmptyMessage} from "../../_defaultComponents/EmptyMessage/EmptyMessage";
import {isArray} from "lodash";
import { StyledTable } from "./courierOnboardingTab/courierSummary/courierEquipmentInformations/CourierEquipmentInformations.styled";

const {Column} = Table;

export const LogTable = ({loading, data, onChange}) => {
    const {t, i18n} = useTranslation(["courierLogTable"]);

    const logs = data?.logs ? data.logs : isArray(data) ? data : [];

    const handleTableChange = pagination => {
        if (onChange) {
            const page = pagination.current;
            const skip = (page - 1) * pagination.pageSize;
            onChange({
                skip,
                limit: pagination.pageSize,
                page
            });
        }
    };

    return (
        <StyledTable
            loading={loading}
            dataSource={logs}
            rowKey="_id"
            data-testid="logTable"
            locale={{emptyText: <EmptyMessage />}}
            onChange={handleTableChange}
            pagination={{
                pageSize: 10,
                total: data?.dataCount || 0,
                showSizeChanger: false
            }}
        >
            <Column
                title={t("fields.username", {ns: "common"})}
                dataIndex="userName"
                render={text => <span data-testid="userName">{text}</span>}
                onCell={() => ({
                    "data-label": t("fields.username", {ns: "common"})
                })}
            ></Column>
            <Column
                title={t("fields.userEmail", {ns: "courierLogTable"})}
                dataIndex="userEmail"
                render={text => <span data-testid="userEmail">{text}</span>}
                onCell={() => ({
                    "data-label": t("fields.userEmail", {ns: "courierLogTable"})
                })}
            ></Column>
            <Column
                title={t("fields.company", {ns: "common"})}
                dataIndex="dedicatedCompany"
                render={text => (
                    <span data-testid="dedicatedCompany">
                        {text && text.length > 0 ? text : t("filters.pool", {ns: "common"})}
                    </span>
                )}
                onCell={() => ({
                    "data-label": t("fields.company", {ns: "common"})
                })}
            ></Column>
            <Column
                title={t("fields.subcompany", {ns: "common"})}
                dataIndex="dedicatedSubCompanies"
                render={text => <span data-testid="dedicatedSubCompanies">{text.join(", ")}</span>}
                onCell={() => ({
                    "data-label": t("fields.subcompany", {ns: "common"})
                })}
            ></Column>

            <Column
                title={t("fields.date", {ns: "common"})}
                dataIndex="timestamp"
                sorter={(a, b) => moment(a.timestamp).unix() - moment(b.timestamp).unix()}
                render={text => (
                    <span data-testid="timestamp">
                        {moment(text)
                            .locale(i18n.resolvedLanguage || "tr")
                            .format("lll")}
                    </span>
                )}
                onCell={() => ({
                    "data-label": t("fields.date", {ns: "common"})
                })}
            ></Column>
        </StyledTable>
    );
};
